// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"styles_logoWrapper__K58vm"};